import { MenuItem, MenuItems } from '@headlessui/react';
import type { MainTableColumn } from './MainTable';
import classNames from 'classnames';
import { Input } from 'alurkerja-ui';
import { Check, Search } from 'lucide-react';

export default function ColumnFilterContent({
  visibleColumns,
  setVisibleColumns,
  variableCols,
  handleSearch,
}: {
  visibleColumns: Set<string>;
  setVisibleColumns: (columns: Set<string>) => void;
  variableCols: MainTableColumn[];
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const handleColumnClick = (column: MainTableColumn) => {
    const newSet = new Set(visibleColumns);
    if (newSet.has(column.name)) {
      newSet.delete(column.name);
    } else {
      newSet.add(column.name);
    }
    setVisibleColumns(newSet);
  };

  const toggleAllVariableColumns = (show: boolean) => {
    const newSet = new Set(visibleColumns);
    variableCols.forEach(col => {
      if (show) {
        newSet.add(col.name);
      } else {
        newSet.delete(col.name);
      }
    });
    setVisibleColumns(newSet);
  };

  return (
    <MenuItems
      className="origin-top-right p-0 border w-64 bg-white shadow-lg z-10 rounded-lg transition duration-100 ease-out data-closed:scale-95 data-closed:opacity-0"
      anchor="bottom end"
    >
      <div className="flex items-center justify-end p-3">
        <div className="flex gap-2">
          <button
            className={classNames('text-xs hover:underline text-blue-600')}
            onClick={() => toggleAllVariableColumns(true)}
          >
            Show All
          </button>
          <button className={classNames('text-xs hover:underline')} onClick={() => toggleAllVariableColumns(false)}>
            Hide All
          </button>
        </div>
      </div>

      <div className="px-3">
        <Input
          placeholder="Search columns"
          name="search"
          size="xs"
          className="rounded-lg"
          prefix={<Search size={14} />}
          onChange={handleSearch}
        />
      </div>

      <div className="!max-h-80 overflow-y-auto scrollbar-none p-3 space-y-1">
        {variableCols.map((column: MainTableColumn) => (
          <MenuItem key={column.name}>
            <button
              className={classNames(
                'w-full flex items-center p-2 text-left text-sm rounded cursor-pointer hover:bg-gray-100',
                {
                  'bg-blue-50 hover:bg-blue-50': visibleColumns.has(column.name),
                },
              )}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                handleColumnClick(column);
              }}
            >
              <span className="flex-1">{column.label}</span>
              {visibleColumns.has(column.name) && (
                <span className="ml-auto my-auto text-xs">
                  <Check size={16} />
                </span>
              )}
            </button>
          </MenuItem>
        ))}
      </div>
    </MenuItems>
  );
}
